module.exports = __webpack_public_path__ + "static/media/11.4592b606.jpg";